import React, {useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import TextInput from 'components/TextInput';
import Select from 'components/Select';
import GridBlock from 'components/GridBlock';
import MeasureUnitService from 'services/MeasureUnitService';
import INPUT_TYPE from 'constants/INPUT_TYPE';
import Loading from "components/Loading";

const style = theme => ({
    root: {
        '&>*': {
            marginLeft: theme.spacing(2)
        }
    },
})

function OfferUnits({
    classes,
    formikProps,
    id,
    disabled
}) {
    const quantityId = `${id}.quantity.value`;
    const unitId = `${id}.quantity.uom`;
    const [measureUnits, setMeasureUnits] = useState(null);

    useEffect(() => {
        MeasureUnitService.getRequired().then((resp) => setMeasureUnits(resp));
    }, []);

    if (!measureUnits) {
        return (
            <Loading/>
        )
    }

    return (
        <GridBlock className={classes.root}>
            <TextInput
                id={quantityId}
                formikProps={formikProps}
                type={INPUT_TYPE.NUMBER_POSITIVE_AMOUNT}
                required
                disabled={disabled}
            />
            <Select
                formikProps={formikProps}
                id={unitId}
                required
                disabled={disabled}
                items={measureUnits}
            />
        </GridBlock>
    )
}

OfferUnits.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(OfferUnits);